<template>
    <span class="order-status-pill" :class="[status, { late }]">
        <DsChip>{{ $t(`OrderStatusPill.orderStatus.${status}`) }}</DsChip>
    </span>
</template>

<script>
import { DsChip } from '@infusionsoft/design-system';
import { getStatus, getQuoteStatus, getRecurringStatus } from '../money.util';

export default {
    name: 'OrderStatusPill',

    components: {
        DsChip,
    },

    props: {
        orderStatus: String,
        isQuote: Boolean,
        isRecurring: Boolean,
        orderId: Number,
        late: Boolean,
        finalPaymentDate: {
            type: String,
            default: '',
        },
    },

    computed: {
        status() {
            if (this.isQuote) {
                return getQuoteStatus(this.orderStatus, this.orderId);
            }

            if (this.isRecurring) {
                return getRecurringStatus(this.orderStatus, this.finalPaymentDate);
            }

            return getStatus(this.orderStatus);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../styles/common';

.order-status-pill {
    --badge-margin: 0;
    max-width: var(--order-status-pill-max-width, 'auto');

    &.complete,
    &.paid,
    &.depositPaid,
    &.invoiced,
    &.accepted-invoiced {
        --chip-background-color: #{$color-green-100};
    }

    &.late,
    &.inactive {
        --chip-background-color: #{$color-red-100};
    }
}
</style>
